import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectSeoReportParams } from '@/shared/api/end-points/project'
import { SeoReportResponse } from '../../lib'

const getSeoReport = async (params: GetProjectSeoReportParams) => {
  return await api.json<SeoReportResponse>(API_END_POINTS.project.getProjectSeoReport(params))
}

export default getSeoReport
